import en from './en';
import fr from './fr';
// Per-area dictionaries — see parts/README.md. Each exports { en, fr } with
// identical key sets; they merge OVER the base so an area can refine a shared
// string without editing the shared file.
import * as guest from './parts/guest';
import * as orders from './parts/orders';
import * as tables from './parts/tables';
import * as menus from './parts/menus';
import * as settings from './parts/settings';
import * as dashboard from './parts/dashboard';
import * as buffet from './parts/buffet';
import * as inventory from './parts/inventory';
import * as admin from './parts/admin';
import * as insights from './parts/insights';
import * as kiosk from './parts/kiosk';
import * as realtime from './parts/realtime';
import * as crm from './parts/crm';
import * as loyalty from './parts/loyalty';
import * as organisation from './parts/organisation';

const PARTS = [guest, orders, tables, menus, settings, dashboard, buffet, inventory, admin, insights, kiosk, realtime, crm, loyalty, organisation];

const EN = Object.assign({}, en, ...PARTS.map((p) => p.en));
const FR = Object.assign({}, fr, ...PARTS.map((p) => p.fr));

export const LOCALES = {
  en: { code: 'en', label: 'English', nativeLabel: 'English', flag: 'EN', dict: EN },
  fr: { code: 'fr', label: 'French',  nativeLabel: 'Français', flag: 'FR', dict: FR },
};

export const DEFAULT_LOCALE = 'en';

// Translate one key, falling back to English and then to the key itself so untranslated strings stay visible.
export function translate(locale, key, params) {
  const dict = LOCALES[locale]?.dict || EN;
  let value = dict[key];
  if (value === undefined) value = EN[key];
  if (value === undefined) value = key;

  if (params) {
    for (const [k, v] of Object.entries(params)) {
      value = value.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    }
  }
  return value;
}
